import complaints from "./complaints.js";
import financialDifficulty from "./financialDifficulty.js";
import tariff from "./tariff.js";
import vulnerableCustomers from "./vulnerableCustomers.js";
import fairTreatment from "./fairTreatment.js";
import regulatoryInformation from "./regulatoryInformation.js";
import investorAccess from "./investorAccess.js";
import intermediaryTerms from "./intermediaryTerms.js";
import financialCrime from "./financialCrime.js";
import whistleblowing from "./whistleblowing.js";
import modernSlavery from "./modernSlavery.js";
import accessibility from "./accessibility.js";
import dataRoomTerms from "./dataRoomTerms.js";

export const policies = [
  complaints,
  financialDifficulty,
  tariff,
  vulnerableCustomers,
  fairTreatment,
  intermediaryTerms,
  regulatoryInformation,
  investorAccess,
  financialCrime,
  whistleblowing,
  modernSlavery,
  accessibility,
  dataRoomTerms
];

export const groups = [
  { key: "uk", title: "UK borrowers", blurb: "Daksfirst Limited as lender. These apply to borrowers, guarantors, applicants and introducers in the United Kingdom." },
  { key: "legal", title: "Legal and regulatory", blurb: "Group-wide pages that apply to every Daksfirst entity and every visitor. Where a page has jurisdiction-specific content, it is set out in labelled sections." }
];

// Pages that exist outside the policy data model but belong in the hub.
export const externalPages = [
  { group: "legal", title: "Privacy policy", to: "/privacy", status: "Published, August 2026" },
  { group: "legal", title: "Website terms of use", to: "/legal#terms", status: "Effective 22 September 2026" },
  { group: "legal", title: "Cookie notice", to: "/legal#cookies", status: "Effective 22 September 2026" }
];

export const indiaCompanies = [
  { name: "Komac Investments and Finance Private Limited", href: "https://kifpl.com", note: "RBI-registered NBFC" },
  { name: "India Finance House", href: "https://ifhl.in", note: "Loan service provider to Komac" },
  { name: "Amol Financial Services Private Limited", href: "https://amolfinance.com", note: "SEBI-registered stock broker, NSE and BSE member, CDSL depository participant" }
];

export function findPolicy(slug) {
  return policies.find((p) => p.slug === slug);
}
